// tslint:disable-next-line:no-shadowed-variable
import {ConfigModel} from '../core/interfaces/config';
import {AppConfigService} from '@service/config/app-config.service';

// tslint:disable-next-line:no-shadowed-variable
export class MenuConfig implements ConfigModel {
    public config: any = {};
    constructor() {
        const appConfig = AppConfigService.config;
        this.config = {
            header: {
                self: {},
                items: [
                    {
                        title: appConfig.phoneNumber || '1-800-000-0000',
                        icon: (appConfig.phoneNumber && appConfig.phoneNumber.includes('@')) ? 'email' : 'call',
                        image: '/assets/images/call.svg',
                        href: false,
                        special: 'call',
                        internal: 1,
                        page: appConfig.phoneNumber || '1-800-000-0000',
                        toggle: 'click',
                        visible: !!(appConfig.phoneNumber && appConfig.phoneNumber.length)
                    },
                    {
                        title: appConfig.phoneNumber2,
                        icon: (appConfig.phoneNumber2 && appConfig.phoneNumber.includes('@')) ? 'email' : 'call',
                        image: '/assets/images/call.svg',
                        href: false,
                        special: 'call',
                        internal: 1,
                        page: appConfig.phoneNumber2,
                        toggle: 'click',
                        visible: !!(appConfig.phoneNumber2 && appConfig.phoneNumber2.length)
                    },
                    {
                        title: appConfig.phoneNumber || '1-800-000-0000',
                        icon: 'sms',
                        image: '/assets/images/sms.svg',
                        href: false,
                        special: 'sms',
                        internal: 1,
                        page: (appConfig.phoneNumber) ? appConfig.phoneNumber.replace(/[^0-9 ]/g, '') : '18000000000',
                        toggle: 'click',
                        visible: appConfig.showSMSLink || false
                    },
                    /*{
                        title: 'Auto Loan Calculator',
                        page: 'https://abc-cx.creditsnap.com/auto-loan-calculator',
                        href: true,
                        internal: 1,
                        toggle: 'click'
                    },*/
                    {
                        title: 'My Application',
                        page: '/myapp',
                        href: true,
                        internal: 1,
                        toggle: 'click',
                        visible: true
                    }/*,
                    {
                        title: 'Sign In',
                        page: '/login.php',
                        href: true,
                        internal: 1,
                        toggle: 'click'
                    }*/
                ]
            }
        };
    }
}
